var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useEffect } from 'react';
import { apiService } from '@/utils/api';
var AuthContext = createContext(undefined);
export var useAuth = function () {
    var context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};
export var AuthProvider = function (_a) {
    var children = _a.children;
    var _b = useState(null), user = _b[0], setUser = _b[1];
    var _c = useState(true), isLoading = _c[0], setIsLoading = _c[1];
    var _d = useState(''), csrfToken = _d[0], setCsrfToken = _d[1];
    // Get CSRF token
    var getCsrfToken = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, token, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, apiService.get('/api/v1/auth/csrf/')];
                case 1:
                    response = _a.sent();
                    token = response.csrfToken;
                    setCsrfToken(token);
                    // Set CSRF token in axios defaults
                    apiService.defaults.headers.common['X-CSRFToken'] = token;
                    return [2 /*return*/, token];
                case 2:
                    error_1 = _a.sent();
                    console.error('Error getting CSRF token:', error_1);
                    return [2 /*return*/, ''];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    // Check authentication status
    var checkAuth = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, 4, 5]);
                    setIsLoading(true);
                    // Get CSRF token first
                    return [4 /*yield*/, getCsrfToken()];
                case 1:
                    // Get CSRF token first
                    _a.sent();
                    return [4 /*yield*/, apiService.get('/api/v1/auth/check/')];
                case 2:
                    response = _a.sent();
                    if (response.isAuthenticated && response.user) {
                        setUser(response.user);
                    }
                    else {
                        setUser(null);
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _a.sent();
                    console.error('Auth check failed:', error_2);
                    setUser(null);
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    // Login function
    var login = function (username, password) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_3;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 4, , 5]);
                    if (!!csrfToken) return [3 /*break*/, 2];
                    return [4 /*yield*/, getCsrfToken()];
                case 1:
                    _c.sent();
                    _c.label = 2;
                case 2: return [4 /*yield*/, apiService.post('/api/v1/auth/login/', {
                        username: username,
                        password: password,
                    })];
                case 3:
                    response = _c.sent();
                    if (response.success && response.user) {
                        setUser(response.user);
                        // Store the auth token
                        if (response.token) {
                            localStorage.setItem('authToken', response.token);
                        }
                        // Store applications and companies for CompanyContext
                        if (response.applications) {
                            localStorage.setItem('availableApplications', JSON.stringify(response.applications));
                        }
                        if (response.companies) {
                            localStorage.setItem('availableCompanies', JSON.stringify(response.companies));
                        }
                        // Notify CompanyContext to refresh
                        window.dispatchEvent(new CustomEvent('auth-data-updated'));
                        return [2 /*return*/, { success: true }];
                    }
                    else {
                        return [2 /*return*/, { success: false, error: response.error || 'Login failed' }];
                    }
                    return [3 /*break*/, 5];
                case 4:
                    error_3 = _c.sent();
                    console.error('Login error:', error_3);
                    if ((_b = (_a = error_3.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) {
                        return [2 /*return*/, { success: false, error: error_3.response.data.error }];
                    }
                    return [2 /*return*/, { success: false, error: 'Network error. Please try again.' }];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    // Logout function
    var logout = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    return [4 /*yield*/, apiService.post('/api/v1/auth/logout/')];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2:
                    error_4 = _a.sent();
                    console.error('Logout error:', error_4);
                    return [3 /*break*/, 4];
                case 3:
                    setUser(null);
                    // Clear CSRF token
                    setCsrfToken('');
                    delete apiService.defaults.headers.common['X-CSRFToken'];
                    // Clear auth token and company data
                    localStorage.removeItem('authToken');
                    localStorage.removeItem('availableApplications');
                    localStorage.removeItem('availableCompanies');
                    localStorage.removeItem('selectedApplication');
                    localStorage.removeItem('selectedCompany');
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    // Check auth on mount
    useEffect(function () {
        checkAuth();
    }, []);
    // Set up axios interceptor for CSRF token
    useEffect(function () {
        var interceptor = apiService.interceptors.request.use(function (config) {
            if (csrfToken && !config.headers['X-CSRFToken']) {
                config.headers['X-CSRFToken'] = csrfToken;
            }
            return config;
        }, function (error) {
            return Promise.reject(error);
        });
        return function () {
            apiService.interceptors.request.eject(interceptor);
        };
    }, [csrfToken]);
    // Set up axios interceptor for handling 401/403 responses
    useEffect(function () {
        var interceptor = apiService.interceptors.response.use(function (response) { return response; }, function (error) { return __awaiter(void 0, void 0, void 0, function () {
            var _a, _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        if (!(((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 401)) return [3 /*break*/, 1];
                        // Token expired or invalid, logout user
                        setUser(null);
                        return [3 /*break*/, 3];
                    case 1:
                        if (!(((_b = error.response) === null || _b === void 0 ? void 0 : _b.status) === 403 && ((_e = (_d = (_c = error.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.detail) === null || _e === void 0 ? void 0 : _e.includes('CSRF')))) return [3 /*break*/, 3];
                        // CSRF token invalid, refresh it
                        return [4 /*yield*/, getCsrfToken()];
                    case 2:
                        // CSRF token invalid, refresh it
                        _f.sent();
                        _f.label = 3;
                    case 3: return [2 /*return*/, Promise.reject(error)];
                }
            });
        }); });
        return function () {
            apiService.interceptors.response.eject(interceptor);
        };
    }, []);
    var value = {
        user: user,
        isAuthenticated: !!user,
        isLoading: isLoading,
        login: login,
        logout: logout,
        checkAuth: checkAuth,
    };
    return (_jsx(AuthContext.Provider, { value: value, children: children }));
};
